import { observer } from 'mobx-react-lite';
import {
    CadNextRelatedDataLocationQuery,
    CadNextRelatedDataVehicleQuery,
    ConsolidatedLocationView,
    EventPersonDto,
    EventVehicleDto,
    RelatedDataPersonQuery,
} from '@mark43/cad-api';
import { RelatedDataTabCommonContent } from '../../event-panel/tabs/related-data/related-data-tab-common-content';
import { useRelatedData } from '../../related-data/use-related-data';
import { TabBody } from '../../panels/entity-panels/tabs/tab-body';
import { BoloPanelTab } from '../bolo-panel/panel-components/tabs/bolo-panel-tab';
import { useApplicationType } from '../../common/hooks/use-application-type';
import { PropsWithChildren } from 'react';
import { FrTabContentWrapper } from '../../fr-event-details-page/components/tabs/styled';
import { VStack } from '@cad-arc';

const TabWrapper = ({ children }: PropsWithChildren<unknown>) => {
    const { isFirstResponder } = useApplicationType();

    if (isFirstResponder) {
        return (
            <FrTabContentWrapper>
                <VStack w="100%">{children}</VStack>
            </FrTabContentWrapper>
        );
    }

    return (
        <BoloPanelTab title="Related Data">
            <TabBody>{children}</TabBody>
        </BoloPanelTab>
    );
};

export const BoloRelatedDataTabContent = observer(
    (props: {
        phoneNumbers: string[];
        vehicles: EventVehicleDto[];
        location?: ConsolidatedLocationView;
        reportingParties: EventPersonDto[];
        vehicleQueries: CadNextRelatedDataVehicleQuery[];
        relatedDataLocationQuery?: CadNextRelatedDataLocationQuery;
        personQueries: RelatedDataPersonQuery[];
    }) => {
        const { viewMoreCadEvents, viewMoreRmsReports, viewMoreVehicles } = useRelatedData();
        const {
            phoneNumbers,
            vehicleQueries,
            relatedDataLocationQuery,
            personQueries,
            ...rest
        } = props;

        return (
            <TabWrapper>
                <RelatedDataTabCommonContent
                    {...rest}
                    phoneNumbers={phoneNumbers}
                    onViewMoreCadEvents={() => {
                        viewMoreCadEvents({
                            isNewEvent: true,
                            newEventFields: {
                                phoneNumbers,
                                vehicleQueries,
                                relatedDataLocationQuery,
                                personQueries,
                            },
                        });
                    }}
                    onViewMoreRmsReports={() => {
                        viewMoreRmsReports({
                            isNewEvent: true,
                            newEventFields: {
                                phoneNumbers,
                                vehicleQueries,
                                relatedDataLocationQuery,
                                personQueries,
                            },
                        });
                    }}
                    onViewMoreVehicles={() => {
                        viewMoreVehicles({
                            isNewEvent: true,
                            newEventFields: {
                                phoneNumbers,
                                vehicleQueries,
                                relatedDataLocationQuery,
                                personQueries,
                            },
                        });
                    }}
                />
            </TabWrapper>
        );
    }
);
